<template>
  <Screen>
    <AppBar
      title="Manage blisscipline workouts"
      :description="`Add or update BIBO app blisscipline workouts of blissciplines`"
      :showBackButton="false"
    >
      <inertia-link
        :href="$route('admin.blisscipline.workouts.create')"
        class="btn btn-sm btn-primary"
      >
        <i class="fa fa-plus"></i>
        <span class="d-none d-app-inline">Add new</span>
      </inertia-link>
    </AppBar>
    <Breadcrumbs title="Blisscipline workouts" />
    <div class="card">
      <div class="card-body">
        <SearchBar
          @onSubmit="searchSubmit"
          @onClear="searchCleared"
          v-model="searchInput"
        />
        <div
          class="alert alert-info"
          style="margin-top: -1rem"
          v-if="hasBlissciplineSearch"
        >
          <small class="font-weight-bold">
            Blisscipline filter is applied. If you want to narrow down the
            search the enter the search term after blisscipline:{id} <br />
            Example: "blisscipline:1 search this"
          </small>
        </div>
        <div class="table-responsive" v-if="data.data.length > 0">
          <table class="table mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Thumbnail</th>
                <th>Title</th>
                <th>Blisscipline</th>
                <th>Time</th>
                <th>Sort order</th>
                <th>Status</th>
                <th>Premium</th>
                <th>Created</th>
                <th>Updated</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in data.data" :key="item.id">
                <td>
                  {{
                    i + 1 + (data.meta.current_page - 1) * data.meta.per_page
                  }}
                </td>
                <td style="width: 0">
                  <div class="position-relative">
                    <img
                      v-lazy="item.thumbnail"
                      :alt="item.title"
                      class="preview-img-sm"
                      width="100"
                      height="100"
                      style="background-color: #f1f1f1"
                    />
                    <a :href="item.animation" class="play-btn" target="_blank">
                      <i class="fa fa-play"></i>
                    </a>
                  </div>
                </td>
                <th style="max-width: 220px">
                  <div>{{ item.title }}</div>
                  <span
                    class="sub-title wrap-text-2"
                    v-text="item.description"
                  ></span>
                </th>
                <th>
                  <inertia-link
                    :href="
                      $route('admin.blisscipline.blisscipline.edit', {
                        id: item.blisscipline_id,
                      })
                    "
                  >
                    {{ item.blisscipline.title }}
                  </inertia-link>
                  <div>
                    <inertia-link
                      :href="
                        $route('admin.blisscipline.workouts.index', {
                          search: 'blisscipline:' + item.blisscipline_id,
                        })
                      "
                      class="btn btn-light btn-rounded-sm"
                      v-tooltip="'View related workouts'"
                    >
                      <i class="fa fa-eye"></i>
                    </inertia-link>
                    <inertia-link
                      :href="
                        $route('admin.blisscipline.workouts.create', {
                          blisscipline: item.blisscipline_id,
                        })
                      "
                      class="btn btn-light btn-rounded-sm"
                      v-tooltip="'Add new workout'"
                    >
                      <i class="fa fa-plus"></i>
                    </inertia-link>
                  </div>
                </th>
                <td>
                  {{ item.minutes || "0" }}:{{ item.seconds || "0" }} mins
                </td>
                <td>{{ item.sort_order }}</td>
                <th>
                  <StatusSwitch
                    :dataid="item.id"
                    :status="item.isactive"
                    action="blissciplineWorkoutStatus"
                  />
                </th>
                <th>
                  <StatusSwitch
                    :dataid="item.id"
                    :status="item.is_premium"
                    labelText="Premium/Free"
                    action="blissciplineWorkoutPremiumStatus"
                  />
                </th>
                <td>{{ item.created_at_human || "-" }}</td>
                <td>{{ item.updated_at_human || "-" }}</td>
                <td>
                  <inertia-link
                    class="btn btn-sm btn-light"
                    :href="
                      $route('admin.blisscipline.workouts.edit', {
                        id: item.id,
                      })
                    "
                  >
                    Update
                  </inertia-link>
                  <button
                    @click.prevent="deleteThis(item.id)"
                    class="btn btn-sm btn-danger"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <NoData title="No blisscipline workouts added yet" v-else>
          <inertia-link
            :href="$route('admin.blisscipline.workouts.create')"
            class="btn btn-primary"
          >
            <i class="fa fa-plus"></i> Add new
          </inertia-link>
        </NoData>
        <Pagination :rawData="data.meta" :onClick="pageChange" />
      </div>
    </div>
  </Screen>
</template>
<script>
export default {
  components: {},
  props: {
    data: {
      type: [Array, Object],
      default: () => [],
    },
    search: {
      type: String,
      default: "",
    },
    hasBlissciplineSearch: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    search: {
      immediate: true,
      handler(value) {
        this.searchInput = value;
      },
    },
  },
  data() {
    return {
      searchInput: "",
    };
  },
  mounted() {},
  methods: {
    async deleteThis(id) {
      this.$root.$emit("confirmModal", {
        title: "Do you want to delete this blisscipline workout?",
        message: "You won't be able to revert this!",
        confirmText: "Yes, delete it!",
        onConfirm: () => {
          this.$root.$emit("hold-transition", null);
          this.$inertia.delete(
            this.$route("admin.blisscipline.workouts.delete", {
              id: id,
            })
          );
        },
      });
    },
    searchSubmit(search) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: search,
          page: 1,
        })
      );
    },
    searchCleared() {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          search: "",
          page: 1,
        })
      );
    },
    pageChange(page) {
      this.$root.$emit("hold-transition", null);
      this.$inertia.visit(
        this.$route(this.$route().current(), {
          page: page,
          search: this.searchInput,
        })
      );
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.play-btn {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: var(--border-radius);
  padding: 10px;
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition);
  &:hover {
    background-color: rgba(0, 0, 0, 0.4);
  }
}
</style>
